export enum TypeCorta {
  sawOne = 'SO',
  sawTwo = 'ST',
  grinded = 'GR'
}
